import React, { useState, useEffect } from 'react';
import Navbar from '../components/Navbar';
import { useAuth } from '../context/AuthContext';
import { CheckCircle } from 'lucide-react';
import API from '../utils/api';

export default function Profile() {
  const { user } = useAuth();
  const [form, setForm] = useState({ full_name:'', city:'', bio:'', instagram:'', youtube:'', vimeo:'', website:'' });
  const [saving, setSaving] = useState(false);
  const [saved, setSaved] = useState(false);

  useEffect(() => { API.get('/api/profile').then(r => { if(r.data.profile) setForm(f=>({...f,...r.data.profile})); }).catch(()=>{}); }, []);

  const set = (k,v) => setForm(f=>({...f,[k]:v}));
  const handleSave = async () => { setSaving(true); try { await API.put('/api/profile',form); setSaved(true); setTimeout(()=>setSaved(false),2500); } catch{} finally{setSaving(false);} };

  return (
    <div style={{ minHeight:'100vh', background:'var(--bg)' }}>
      <Navbar />
      <div style={{ maxWidth:580, margin:'0 auto', padding:'40px 24px' }}>
        <div style={{ display:'flex', alignItems:'center', gap:16, marginBottom:36 }}>
          <div style={{ width:62, height:62, borderRadius:'50%', background:'var(--pink)', display:'flex', alignItems:'center', justifyContent:'center', fontSize:26, fontWeight:900, color:'#fff', overflow:'hidden', flexShrink:0 }}>
            {user?.avatar_url ? <img src={user.avatar_url} alt="" style={{ width:'100%',height:'100%',objectFit:'cover' }} /> : (user?.name||'U')[0].toUpperCase()}
          </div>
          <div style={{ flex:1 }}>
            <h1 style={{ fontWeight:900, fontSize:24, color:'var(--text)', marginBottom:3, letterSpacing:'-0.01em' }}>{user?.name}</h1>
            <p style={{ fontSize:12, color:'var(--text-muted)', fontWeight:500 }}>{user?.email}</p>
          </div>
          {saved && <div style={{ display:'flex', alignItems:'center', gap:5, color:'var(--green)', fontSize:12, fontWeight:700 }}><CheckCircle size={14} color="var(--green)"/>Saved</div>}
        </div>
        {[{title:'Basic Info',fields:[['full_name','Full Name','Your full name','text'],['city','City','e.g. Chennai, Mumbai','text'],['bio','Bio','Short bio as a filmmaker','textarea']]},{title:'Social Links',fields:[['instagram','Instagram','https://instagram.com/yourhandle','url'],['youtube','YouTube','https://youtube.com/@channel','url'],['vimeo','Vimeo','https://vimeo.com/profile','url'],['website','Website','https://yoursite.com','url']]}].map(sec => (
          <div key={sec.title} style={{ marginBottom:28 }}>
            <div style={{ paddingBottom:12, marginBottom:16, borderBottom:'1.5px solid var(--border)' }}>
              <h3 style={{ fontWeight:800, fontSize:16, color:'var(--text)' }}>{sec.title}</h3>
            </div>
            {sec.fields.map(([k,l,p,t]) => (
              <div key={k} style={{ marginBottom:14 }}>
                <label style={{ display:'block', fontSize:10, fontWeight:800, color:'var(--text-secondary)', marginBottom:5, textTransform:'uppercase', letterSpacing:'0.08em' }}>{l}</label>
                {t==='textarea'
                  ? <textarea value={form[k]} onChange={e=>set(k,e.target.value)} placeholder={p} rows={3} />
                  : <input type={t} value={form[k]} onChange={e=>set(k,e.target.value)} placeholder={p} />}
              </div>
            ))}
          </div>
        ))}
        <button onClick={handleSave} disabled={saving} className="btn-primary" style={{ width:'100%', padding:'13px', fontSize:13 }}>
          {saving ? 'Saving...' : 'Save Profile'}
        </button>
      </div>
    </div>
  );
}
